import React, { useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { deleteGallery, deleteMultipleImages, getSingleGallery } from '../../utils/api-calls'
import styled from 'styled-components'
import { rel8White } from '../../globals';
import Loading from '../Loading/Loading'
import { toast } from 'react-toastify'
import { mobile, tablet } from '../../responsive'
import { AddGalleryImages } from './AddGalleryImages'
import SubConComponent from './SubConComponent'

const BackDrop = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
`
const SubCon = styled.div`
    background-color: ${rel8White};
    width: 80%;
    border-radius: 10px;
    height: 500px;
    overflow-y: auto;
    padding: 20px;
`

// const ImageCon = styled.div`
//   display: grid;
//   grid-template-columns: auto auto auto;
//   gap: 20px;

//   ${
//     mobile({
//       gridTemplateColumns: "auto",
//     })
//   }

//   ${
//     tablet({
//       gridTemplateColumns: "auto auto"
//     })
//   }
// `
// const Image = styled.img`
//   height: 200px;
//   width: 200px;
//   object-fit: contain;
//   border-radius: 8px;
// `

// Define your styled components
const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Creates 3 equal-width columns */
  gap: 20px;

  ${
    mobile({
      gridTemplateColumns: "1fr", /* Stacks images in a single column on mobile */
    })
  }

  ${
    tablet({
      gridTemplateColumns: "1fr 1fr" /* Two columns on tablet */
    })
  }
`;

const ImageContainer = styled.div`
  position: relative;
  cursor: pointer;
  border: 2px solid ${props => props.isSelected ? 'blue' : 'transparent'};
  border-radius: 4px;
  overflow: hidden;

  &:hover {
    opacity: 0.9;
  }
`;

const Image = styled.img`
  width: 100%; /* Ensures image takes up full width of its grid cell */
  height: 200px; /* Fixed height for uniformity */
  object-fit: cover; /* Crops images to fill the area without distortion */
  border-radius: 8px; /* Optional: Rounded corners */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); /* Optional: adds a subtle shadow */
  object-position: top; /* Focuses on the top of the image */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); /* Optional: adds a subtle shadow */
`

const SelectionIndicator = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: blue;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DeleteButton = styled.button`
  background: red;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  margin-bottom: 16px;
  cursor: pointer;
  font-weight: bold;
  
  &:hover {
    background: darkred;
  }
`;

const SingleGallery = ({id, close}) => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, isError, data } = useQuery(`gallery-${id}`, ()=>getSingleGallery(Number(id)), {
    refetchOnWindowFocus: false,
    select: data => data.data
  })

  const { isLoading:deleteLoading, mutate } = useMutation((id)=>deleteGallery(id), {
    onMutate: () => {
      toast.info("Gallery Deletion in progress",{progressClassName:"toastProgress",icon:false})
    },
    onSuccess: () => {
        toast.success("Gallery Deleted",{progressClassName:"toastProgress",icon:false})
        queryClient.invalidateQueries("all-galleries")
        close()
    },
    onError: (error) => {
        toast.error("Could not delete gallery")
        if(error?.message?.response?.data?.message){
            toast.error(`Message: ${error.message.response.data.message}`, {autoClose: 9000})
        }
    }
  });

  const deleteGalleryHandler = (id) => {
    mutate(id);
  }

  const [selectedImages, setSelectedImages] = useState([]);
  const [showUpload, setShowUpload] = useState(false);

  // Toggle selection state when an image is clicked
  const toggleImageSelection = (imageId) => {
    setSelectedImages((prevSelected) =>
      prevSelected.includes(imageId)
        ? prevSelected.filter((id) => id !== imageId)
        : [...prevSelected, imageId]
    );
  }

  const {isLoading: isDeletingImages, mutate: mutateDeleteImages} = useMutation(
    (ids) => deleteMultipleImages(id, { image_ids: ids }),
    {
      onSuccess: () => {
        // Clear selection
        setSelectedImages([]);

        queryClient.invalidateQueries(`gallery-${id}`);
      },
      onError: () => {
        toast.error("Failed to delete images");
      }
    }
  );

  const deleteImagesHandler = () => {
    mutateDeleteImages(selectedImages);
  }

  return (
    <BackDrop>
      <style>
          {`
              body{
                  overflow:hidden;
              }
          `}
      </style>
      { (isLoading||isFetching) ? <Loading loading={isLoading || isFetching}/> : (!isError) ? 

      <SubCon>
        <SubConComponent
          data={data}
          setShowUpload={setShowUpload}
          showUpload={showUpload}
          deleteLoading={deleteLoading}
          deleteGalleryHandler={deleteGalleryHandler}
          close={close}
        />

          {showUpload && (<AddGalleryImages galleryId={id} />)}

          {selectedImages.length > 0 && (
            <DeleteButton
              onClick={deleteImagesHandler}
              disabled={isDeletingImages}
            >
              { isDeletingImages ? 'Deleting...' : `Delete Selected (${selectedImages.length})`}
            </DeleteButton>
          )}

          <ImageGrid>
            {
              data.images.map((item,index) => (
                <ImageContainer
                  isSelected={selectedImages.includes(item.id)}
                  onClick={() => toggleImageSelection(item.id)}
                >
                  <Image
                    alt=''
                    src={item.image}
                    key={index}
                  />
                  {selectedImages.includes(item.id) && (
                    <SelectionIndicator>
                      ✓
                    </SelectionIndicator>
                  )}
                </ImageContainer>
              ))
            }
          </ImageGrid>

      </SubCon>
      : <small>Can't Fetch Details</small> }
  </BackDrop>
  )
}

export default SingleGallery